module.exports = __webpack_public_path__ + "fonts/Moderat Regular.3b1a07ce.otf";